// « Autres encaissements du jour » — the day's payments for guests on neither
// desk sheet (PMS-TERMINAL-LINK-BRIEF §8.8p, operator 2026-09-27): a debtor
// paying, a mid-stay guest, a note paid the morning after leaving, a bar sale,
// a deposit for a later stay. Each in its shift: the tab its form entry was
// taken on, else check-in — so each page lists its own, counted in its band,
// and « Journée » shows both.

import type { IsoDate, OtherTaking } from '@lemontaigu/pms-core';
import { fmtAmount } from './logic.js';
import { otherContext, TAKINGS_TILES, timeParis } from './departureSheet.js';
import { NotInVega } from './PaymentList.js';

const TILE_LABEL = new Map<string, string>(TAKINGS_TILES.map((t) => [t.bucket, t.label]));

/** « LEACH · note 26002442 · parti le 24/09 », « BAR · note 26002478 ». */
function forWhom(o: OtherTaking, day: IsoDate): string {
  const ref = o.facture ? `note ${o.facture}` : o.bookingRef ? `résa ${o.bookingRef}` : null;
  const context = otherContext(o, day);
  return [o.partyLabel ?? '—', ref, context].filter(Boolean).join(' · ');
}

export function OtherTakings({ rows, day, label }: { rows: OtherTaking[]; day: IsoDate; label: string }) {
  const total = rows.filter((o) => o.bucket !== 'outside').reduce((t, o) => t + o.cents, 0);
  return (
    <div className="pms-table-wrap">
      <table className="pms-table" aria-label={label}>
        <thead>
          <tr>
            <th>Heure</th>
            <th>Pour</th>
            <th>Mode</th>
            <th>Montant</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((o, i) => {
            const outside = o.bucket === 'outside';
            return (
              <tr key={i}>
                <td>
                  {o.source === 'form' && <NotInVega />}
                  {o.at ? timeParis(o.at) : '—'}
                </td>
                <td>{forWhom(o, day)}</td>
                <td>{outside ? <span className="pms-sub">{o.label ?? 'Autre'} · hors caisse</span> : TILE_LABEL.get(o.bucket)}</td>
                <td className="pms-num">{outside ? <span className="pms-sub">{fmtAmount(o.cents)}</span> : fmtAmount(o.cents)}</td>
              </tr>
            );
          })}
          {rows.length === 0 && (
            <tr>
              <td colSpan={4} className="pms-empty">
                Aucun autre encaissement ce jour-là.
              </td>
            </tr>
          )}
        </tbody>
        {rows.length > 0 && (
          <tfoot>
            <tr>
              <td colSpan={3} className="pms-sub">
                {rows.length} encaissement{rows.length > 1 ? 's' : ''}
              </td>
              <td className="pms-num">{fmtAmount(total)}</td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}
